import moment from 'moment-timezone'
import { SportEventsIndex, LeagueEventsIndex, EventIndex, TeaserMarketLineOU, TeaserMarketLineHDP, EventOrder } from "../common/Foundation";
import CommonUtil from "../common/CommonUtil";


export default class OddsDataAdapter {
  /**
   * 
   * @param {*} oddsData 
   * 
   * convert Service Data to Events support render Teaser Lines Page
   */
  static convertTeaserDataToEvents(oddsDataRespone,filter) {
    let dataTeaserConverted = [];
    let oddsData = oddsDataRespone;
    if (oddsData && oddsData.length > 0) {
      let sportId = oddsData[SportEventsIndex.id];
      let sportName = oddsData[SportEventsIndex.name];
      let leagues = oddsData[SportEventsIndex.leagues];
      if (leagues && leagues.length > 0) {
        leagues.forEach((league) => {
          let leagueId = league[LeagueEventsIndex.id];

          let leagueConverted = {
            sportId: sportId,
            sportName: sportName,
            leagueId: leagueId,
            leagueName: league[LeagueEventsIndex.name],
            events: []
          };

          let events = league[LeagueEventsIndex.events];
          if (events && events.length > 0) {
            events.forEach((event) => {
              let eventId = event[EventIndex.id], time = event[EventIndex.time];

              let eventConverted = {
                eventId: eventId,
                eventDate: time,
                rotNum: event[EventIndex.rotNum],
                date: moment(new window.DateTZ(time)).format('MM/DD'),
                time: moment(new window.DateTZ(time)).format('HH:mm'),
                isLive: Boolean(event[EventIndex.live]),
                teamTypes: event[EventIndex.teamType],
                teamNames: {
                  home: event[EventIndex.homeName],
                  away: event[EventIndex.awayName]
                },
                eventStatus: event[EventIndex.eventStatus]
              }

              let periods = event[EventIndex.periods][0];
              if (periods && periods.length > 0) {
                let hdpData = periods[0][0], ouData = periods[1][0]
                // Init Teaser Market Line HDP data
                if (hdpData) {
                  let teamTypes = event[EventIndex.teamType]
                  let homeTeam = {
                    name: event[EventIndex.homeName],
                    teamType: teamTypes[0],
                    id: hdpData[TeaserMarketLineHDP.id],
                    teaserId: hdpData[TeaserMarketLineHDP.teaserId],
                    points: hdpData[TeaserMarketLineHDP.homePoint],
                    keyId: eventId + '|0|2|0|' + hdpData[TeaserMarketLineHDP.selectedPoint] + '|' + hdpData[TeaserMarketLineHDP.teaserId],
                    alt: hdpData[TeaserMarketLineHDP.alt],
                    fav: hdpData[TeaserMarketLineHDP.homeFav]
                  }

                  let awayTeam = {
                    name: event[EventIndex.awayName],
                    teamType: teamTypes[1],
                    id: hdpData[TeaserMarketLineHDP.id],
                    teaserId: hdpData[TeaserMarketLineHDP.teaserId],
                    points: hdpData[TeaserMarketLineHDP.awayPoint],
                    keyId: eventId + '|0|2|1|' + hdpData[TeaserMarketLineHDP.selectedPoint] + '|' + hdpData[TeaserMarketLineHDP.teaserId],
                    alt: hdpData[TeaserMarketLineHDP.alt],
                    fav: hdpData[TeaserMarketLineHDP.awayFav]
                  }

                  eventConverted.hdp = {
                    home: homeTeam,
                    away: awayTeam
                  }
                }

                // Init Teaser Market Line OU data
                if (ouData) {
                  eventConverted.ou = {
                    overPoint: ouData[TeaserMarketLineOU.overPoint],
                    underPoint: ouData[TeaserMarketLineOU.underPoint],
                    teaserId: ouData[TeaserMarketLineOU.teaserId],
                    selectedPoint: ouData[TeaserMarketLineOU.selectedPoint],
                    id: ouData[TeaserMarketLineOU.id],
                    alt: ouData[TeaserMarketLineOU.alt],
                    okeyId: eventId + '|0|3|3|' + ouData[TeaserMarketLineOU.selectedPoint] + '|' + ouData[TeaserMarketLineOU.teaserId],
                    ukeyId: eventId + '|0|3|4|' + ouData[TeaserMarketLineOU.selectedPoint] + '|' + ouData[TeaserMarketLineOU.teaserId]
                  }
                }
              }
              leagueConverted.events.push(eventConverted);
            })
            if(filter['order'] === EventOrder.Time){
              leagueConverted.events = leagueConverted.events.sort(function(a, b){return a["eventDate"] - b["eventDate"]});
            }
          }
          dataTeaserConverted.push(leagueConverted);
        })
      }
    }
    return dataTeaserConverted
  }
}



// WEBPACK FOOTER //
// ./src/app/common/OddsDataAdapter.js